import { Card, Button, Container, Row, Col } from "react-bootstrap";
import logofull from "../../../images/logo-full.png";

const jobs = [
  {
    title: "Frontend Developer and Python Developer Internship",
    salary: "20000 - 30000",
    location: "Pune",
    companyName: "IBM",
    companyLogo: `${logofull}`,
  },
  {
    title: "Python Developer Internship",
    salary: "20000 - 25000",
    location: "Pune",
    companyName: "Infosys",
    companyLogo: `${logofull}`,
  },
  {
    title: "Full Stack Web Developer",
    salary: "15000 - 20000",
    location: "Pune",
    companyName: "Tech Mahindra",
    companyLogo: `${logofull}`,
  },
  {
    title: "Data Scientist Internship",
    salary: "15000 - 20000",
    location: "Pune",
    companyName: "SevenMentor pvt.ltd intern",
    companyLogo: `${logofull}`,
  },
];

const JobList = () => {
  return (
    <Container fluid className="mt-1 px-3">
      <h4 className="text-start mb-3">Job Openings:</h4>
      <Row className="gx-3 gy-4 d-flex justify-content-start text-center">
        {jobs.map((job, index) => (
          <Col
            key={index}
            xs={12}
            sm={6}
            md={4}
            lg={4}
            xl={4}
            className="d-flex justify-content-center"
          >
            <Card
              className="h-70 shadow-sm p-0 d-flex flex-column hover-effect text-dark"
              style={{ borderRadius: "10px", width: "95%" }}
            >
              <Card.Body className="d-flex flex-column text-start">
                <div className="mb-0" style={{ minHeight: "20px" }}>
                  <Card.Title
                    className="text-wrap"
                    style={{
                      fontSize: "clamp(1rem, 1.1vw, 1.2rem)",
                      fontWeight: "600",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                    }}
                  >
                    {job.title}
                  </Card.Title>
                </div>

                <hr className="my-1" />

                <div className="mb-1">
                  <small style={{ fontSize: "15px", fontWeight: "600" }}>
                    Salary:
                  </small>
                  <small style={{ fontSize: "15px", fontWeight: "500" }}>
                    {" "}
                    {job.salary}
                  </small>
                </div>

                {/* Location Section */}
                <div className="mb-1">
                  <small
                    style={{
                      fontSize: "15px",
                      fontWeight: "600",
                    }}
                  >
                    Location:
                  </small>
                  <small
                    style={{
                      fontSize: "15px",
                      fontWeight: "500",
                    }}
                  >
                    {" "}
                    {job.location}
                  </small>
                </div>

                <hr className="my-1" />

                {/* Company Section */}
                <div className="d-flex justify-content-between align-items-center p-0 mb-1">
                  <div className="d-flex align-items-center">
                    <img
                      src={job.companyLogo || "/placeholder.svg"}
                      alt={`${job.companyName} logo`}
                      style={{
                        width: "30px",
                        height: "30px",
                        marginRight: "8px",
                      }}
                      className="rounded-circle"
                    />
                    <div className="d-flex flex-column">
                      <small
                        style={{
                          fontSize: "15px",
                          fontWeight: "600",
                        }}
                      >
                        Company Name:
                      </small>
                      <small
                        style={{
                          fontSize: "15px",
                          fontWeight: "500",
                        }}
                      >
                        {job.companyName}
                      </small>
                    </div>
                  </div>
                </div>

                {/* Button at Bottom */}
                <div className="mt-auto">
                  <Button
                    className="w-100"
                    style={{
                      backgroundColor: "#f97316",
                      fontSize: "clamp(0.9rem, 1vw, 1.1rem)",
                    }}
                  >
                    Read More
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default JobList;
